import { render } from "./OverlayCardDetails.vue?vue&type=template&id=34152698"
import script from "./OverlayCardDetails.vue?vue&type=script&lang=js"
export * from "./OverlayCardDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__